import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchData } from "../../redux/slices/mainDataSlice";
import toast from "react-hot-toast";
import axios from "axios";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faUserSlash,
  faSearch,
  faTrashAlt,
  faFilter,
  faCheck,
  faCheckDouble,
} from "@fortawesome/free-solid-svg-icons";
import "../../main.scss";
import Can from "../../permissions/Can";

const TransferredTeachers = () => {
  const dispatch = useDispatch();
  const transferredTeachers = useSelector(
    (state) => state.main.data?.transferredTeachersData || []
  );
  const schoolsData = useSelector((state) => state.main.data?.schoolData || []);
  const jobsData = useSelector((state) => state.main.data?.anwa3wathtbl || []);
  const [loading, setLoading] = useState(true);
  const [selectedTeachers, setSelectedTeachers] = useState([]);
  const [filter, setFilter] = useState("");

  useEffect(() => {
    if (
      transferredTeachers.length === 0 ||
      schoolsData.length === 0 ||
      jobsData.length === 0
    ) {
      dispatch(fetchData()).finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, [
    dispatch,
    transferredTeachers.length,
    schoolsData.length,
    jobsData.length,
  ]);

  const getSchoolName = (rgmw) => {
    const school = schoolsData.find((s) => Number(s.rgmw) === Number(rgmw));
    return school ? school.schoolname : "تتبع مديرية";
  };

  const getJobName = (wathId) => {
    const job = jobsData.find((j) => Number(j.WathID) === Number(wathId));
    return job ? job.W_Name : "";
  };

  const formatDateSimple = (dateStr) => {
    if (!dateStr) return "غير متوفر";
    const date = new Date(dateStr);
    return `${String(date.getDate()).padStart(2, "0")}/${String(
      date.getMonth() + 1
    ).padStart(2, "0")}/${date.getFullYear()}`;
  };

  const formatTimeSimple = (dateStr) => {
    if (!dateStr) return "";
    const date = new Date(dateStr);
    if (isNaN(date.getTime())) return "";
    let h = date.getHours();
    const ampm = h >= 12 ? "PM" : "AM";
    h = h % 12 || 12;
    return `${String(h).padStart(2, "0")}:${String(date.getMinutes()).padStart(
      2,
      "0"
    )} ${ampm}`;
  };

  const handleFilterChange = (e) => setFilter(e.target.value.toLowerCase());

  // قبول الموظف المنقول (mgboul: 1 -> 0)
  const handleAccept = (id, name) => {
    toast(
      (t) => (
        <div className="confirm-toast">
          <p>قبول {name} في المدرسة؟</p>
          <div className="toast-actions">
            <button
              onClick={async () => {
                const l = toast.loading("جارٍ القبول...");
                try {
                  const credentials = JSON.parse(
                    localStorage.getItem("userCredentials")
                  );
                  const token = credentials?.token;
                  await axios.put(
                    `https://api.alfares.cloud/api/alfares/teachers_tnglat/${id}/${token}`,
                    { mgboul: 0 }
                  );
                  dispatch(fetchData(true));
                  toast.success("تم قبول الموظف في المدرسة");
                } catch {
                  toast.error("فشل القبول");
                } finally {
                  toast.dismiss(l);
                  toast.dismiss(t.id);
                }
              }}
              className="btn-confirm"
            >
              نعم، قبول
            </button>
            <button onClick={() => toast.dismiss(t.id)} className="btn-cancel">
              إلغاء
            </button>
          </div>
        </div>
      ),
      { duration: 6000 }
    );
  };

  // قبول كل العالقين دفعة واحدة
  const handleAcceptAll = () => {
    const pending = transferredTeachers.filter((t) => t.mgboul !== 0);
    if (pending.length === 0) return toast.error("لا يوجد عالقون للقبول");
    toast(
      (t) => (
        <div className="confirm-toast">
          <p>قبول كل العالقين ({pending.length}) في مدارسهم؟</p>
          <div className="toast-actions">
            <button
              onClick={async () => {
                const l = toast.loading("جارٍ قبول الكل...");
                try {
                  const credentials = JSON.parse(
                    localStorage.getItem("userCredentials")
                  );
                  const token = credentials?.token;
                  for (let teacher of pending) {
                    await axios.put(
                      `https://api.alfares.cloud/api/alfares/teachers_tnglat/${teacher.id}/${token}`,
                      { mgboul: 0 }
                    );
                  }
                  dispatch(fetchData(true));
                  toast.success(`تم قبول ${pending.length} موظف`);
                } catch {
                  toast.error("فشل قبول الكل");
                } finally {
                  toast.dismiss(l);
                  toast.dismiss(t.id);
                }
              }}
              className="btn-confirm"
            >
              نعم، قبول الكل
            </button>
            <button onClick={() => toast.dismiss(t.id)} className="btn-cancel">
              إلغاء
            </button>
          </div>
        </div>
      ),
      { duration: 6000 }
    );
  };

  const filteredTeachers = transferredTeachers
    ?.filter((t) =>
      (t.emp_name || t.teacher_name || "").toLowerCase().includes(filter)
    )
    ?.sort((a, b) => new Date(b.ing_date || 0) - new Date(a.ing_date || 0));

  const toggleSelectTeacher = (id) => {
    setSelectedTeachers((prev) =>
      prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]
    );
  };

  const handleDeleteSelected = async () => {
    if (selectedTeachers.length === 0)
      return toast.error("يرجى اختيار موظفين أولاً");

    toast(
      (t) => (
        <div className="confirm-toast">
          <p>هل أنت متأكد من حذف {selectedTeachers.length} موظف؟</p>
          <div className="toast-actions">
            <button
              onClick={async () => {
                const l = toast.loading("جارٍ الحذف...");
                try {
                  const credentials = JSON.parse(
                    localStorage.getItem("userCredentials")
                  );
                  const token = credentials?.token;
                  for (let id of selectedTeachers) {
                    await axios.delete(
                      `https://api.alfares.cloud/api/alfares/teachers_tnglat/${id}/${token}`
                    );
                  }
                  dispatch(fetchData(true));
                  setSelectedTeachers([]);
                  toast.success("تم الحذف بنجاح");
                } catch {
                  toast.error("فشل الحذف");
                } finally {
                  toast.dismiss(l);
                  toast.dismiss(t.id);
                }
              }}
              className="btn-confirm"
            >
              نعم، احذف
            </button>
            <button onClick={() => toast.dismiss(t.id)} className="btn-cancel">
              إلغاء
            </button>
          </div>
        </div>
      ),
      { duration: 6000 }
    );
  };

  return (
    <div className="transferred-wrapper anim-fade-in">
      <div className="premium-edit-container" style={{ maxWidth: "1280px" }}>
        {/* Premium Compact Header */}
        <div className="premium-header-modern">
          <div className="header-left">
            <div className="header-icon-box">
              <FontAwesomeIcon icon={faUserSlash} />
            </div>
            <div className="header-text-box">
              <h2>سجل تنقلات وحركات الموظفين</h2>
              <div className="breadcrumb-info">
                <span>نظام الفارس</span>
                <span className="separator">/</span>
                <span className="current-page">
                  سجل تنقلات الموظفين بين المدارس
                </span>
              </div>
            </div>
          </div>

          <div className="header-tools">
            <div className="global-search-container">
              <FontAwesomeIcon icon={faSearch} className="s-icon" />
              <input
                type="text"
                placeholder={`ابحث عن اسم، رقم وظيفي، أو تخصص... (${filteredTeachers.length} حركة)`}
                value={filter}
                onChange={handleFilterChange}
              />
            </div>

            <Can module="employees" action="delete">
              <button
                className={`bulk-delete-btn ${
                  selectedTeachers.length > 0 ? "show" : ""
                }`}
                onClick={handleDeleteSelected}
              >
                <FontAwesomeIcon icon={faTrashAlt} />
                <span>حذف المحدد ({selectedTeachers.length})</span>
              </button>
            </Can>

            <button className="accept-all-btn" onClick={handleAcceptAll}>
              <FontAwesomeIcon icon={faCheckDouble} />
              <span>قبول الكل</span>
            </button>
          </div>
        </div>

        {/* Content Section */}
        <div className="premium-content-area">
          {loading ? (
            <div className="loader-overlay">
              <div className="premium-loader"></div>
              <span>جارٍ جلب السجلات...</span>
            </div>
          ) : filteredTeachers.length > 0 ? (
            <div className="table-wrapper transfers-table-wrapper">
              <table className="excel-table transfers-table">
                <thead>
                  <tr>
                    <th style={{ width: "40px" }}>
                      <input
                        type="checkbox"
                        checked={
                          filteredTeachers.length > 0 &&
                          selectedTeachers.length === filteredTeachers.length
                        }
                        onChange={(e) => {
                          if (e.target.checked) {
                            setSelectedTeachers(filteredTeachers.map((t) => t.id));
                          } else {
                            setSelectedTeachers([]);
                          }
                        }}
                      />
                    </th>
                    <th>#</th>
                    <th>اسم الموظف</th>
                    <th>المدرسة المنقول منها</th>
                    <th>المدرسة المنقول إليها</th>
                    <th>الوظيفة</th>
                    <th>الجنس</th>
                    <th>التاريخ والوقت</th>
                    <th>الحالة</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredTeachers.map((teacher, idx) => {
                    const isSelected = selectedTeachers.includes(teacher.id);
                    return (
                      <tr
                        key={teacher.id}
                        className={isSelected ? "row-selected" : ""}
                      >
                        <td data-label="select">
                          <input
                            type="checkbox"
                            checked={isSelected}
                            onChange={() => toggleSelectTeacher(teacher.id)}
                          />
                        </td>
                        <td data-label="#">{idx + 1}</td>
                        <td data-label="name">{teacher.emp_name || teacher.teacher_name || "غير محدد"}</td>
                        <td data-label="من مدرسة">{getSchoolName(teacher.school_rgmw)}</td>
                        <td data-label="إلى مدرسة">{getSchoolName(teacher.otherschool_rgmw)}</td>
                        <td data-label="الوظيفة">{getJobName(teacher.W_Num) || "-"}</td>
                        <td data-label="الجنس">
                          <span
                            className={
                              teacher.emp_gender === 1
                                ? "gender-text-m"
                                : "gender-text-f"
                            }
                          >
                            {teacher.emp_gender === 1 ? "ذكر" : "أنثى"}
                          </span>
                        </td>
                        <td data-label="التاريخ" className="datetime-cell">
                          {teacher.ing_date ? (
                            <>
                              <div className="dt-date">
                                {formatDateSimple(teacher.ing_date)}
                              </div>
                              <div className="dt-time">
                                {formatTimeSimple(teacher.ing_date)}
                              </div>
                            </>
                          ) : (
                            "-"
                          )}
                        </td>
                        <td data-label="الحالة" className="status-cell">
                          {teacher.mgboul === 0 ? (
                            <span className="status-pill accepted">مقبول</span>
                          ) : (
                            <button
                              className="accept-row-btn"
                              onClick={() =>
                                handleAccept(
                                  teacher.id,
                                  teacher.emp_name || teacher.teacher_name || "الموظف"
                                )
                              }
                            >
                              <FontAwesomeIcon icon={faCheck} />
                              قبول
                            </button>
                          )}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          ) : (
            <div className="empty-ui-state">
              <FontAwesomeIcon icon={faFilter} className="icon" />
              <h3>لا توجد سجلات مطابقة</h3>
              <p>جرّب استخدام كلمات بحث مختلفة أو تأكد من الفلاتر</p>
            </div>
          )}
        </div>
      </div>

      <style>{`
        .transferred-wrapper {
          padding: 5px;
          color: var(--text);
          font-family: 'Cairo', sans-serif;
        }

        .premium-edit-container {
          margin: 0;
          background: transparent;
          border: none;
          border-radius: 0;
          overflow: visible;
          box-shadow: none;
          width: 100%;
        }

        .premium-header-modern {
          padding: 20px 30px;
          background: #ffffff;
          border: 1px solid var(--border);
          border-radius: 6px 6px 0 0;
          display: flex;
          flex-direction: column;
          gap: 15px;
          direction: rtl;
          text-align: right;
          position: sticky;
          top: 0;
          z-index: 1000;
          isolation: isolate;
          overflow: hidden;
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
        }
        
        .premium-content-area { 
          padding: 25px 30px 30px;
          background: var(--panel);
          border: 1px solid var(--border);
          border-top: none;
          border-radius: 0 0 6px 6px;
          margin-top: -1px;
        }

        .header-left { 
          display: flex; 
          align-items: center; 
          gap: 12px; 
          justify-content: flex-start;
          width: 100%;
        }
        
        .header-text-box {
          text-align: right;
        }

        .header-icon-box {
          width: 40px; height: 40px;
          background: var(--accent);
          border-radius: 6px;
          display: flex; align-items: center; justify-content: center;
          font-size: 18px; color: white;
          flex-shrink: 0;
        }

        .header-text-box h2 { margin: 0; font-size: 18px; font-weight: 400; text-align: right; font-family: "Cairo", sans-serif; }
        .breadcrumb-info { display: flex; align-items: center; gap: 4px; color: var(--muted); font-size: 11px; justify-content: flex-start; }

        .header-tools { 
          display: flex; 
          flex-direction: row; 
          gap: 10px; 
          width: 100%;
          align-items: center;
        }

        .global-search-container {
          background: var(--panel-2);
          border: 1px solid var(--border);
          border-radius: 6px;
          padding: 0 14px;
          display: flex;
          align-items: center;
          gap: 10px;
          height: 44px;
          flex: 1;
          min-width: 0;
          box-sizing: border-box;
          transition: all 0.2s ease;
          margin: 0;
        }
        
        .global-search-container:focus-within {
          border-color: var(--accent);
          box-shadow: 0 0 0 3px color-mix(in srgb, var(--accent) 15%, transparent);
        }
        
        .global-search-container input {
          background: transparent;
          border: none;
          color: var(--text);
          font-size: 14px;
          width: 100%;
          outline: none;
          text-align: right;
        }
        
        .global-search-container input::placeholder {
          color: var(--muted);
        }
        
        .s-icon {
          color: var(--muted);
          font-size: 16px;
        }
        
        .results-count {
          background: var(--panel-2);
          padding: 0 15px;
          border-radius: 6px;
          font-size: 13px;
          color: var(--muted);
          border: 1px solid var(--border);
          display: flex;
          align-items: center;
          gap: 6px;
          height: 44px;
          white-space: nowrap;
          transition: all 0.3s;
          margin-right: auto;
        }
        .results-count:hover { border-color: var(--accent); background: rgba(var(--accent-rgb), 0.05); }
        .results-count b { color: var(--accent); font-size: 15px; }

        .bulk-delete-btn {
          background: #ef4444;
          color: white;
          border: none;
          border-radius: 10px;
          padding: 10px;
          display: none; /* Hidden by default */
          align-items: center; justify-content: center; gap: 8px;
          font-size: 13px; font-weight: 700;
          cursor: pointer;
          transition: 0.2s;
          width: 100%;
          font-family: 'Cairo', sans-serif !important; /* Force Cairo font */
        }
        
        .bulk-delete-btn.show {
          display: flex; /* Show only when 'show' class is present */
        }

        .accept-all-btn {
          background: #10b981;
          color: white;
          border: none;
          border-radius: 10px;
          padding: 10px 18px;
          display: flex;
          align-items: center; justify-content: center; gap: 8px;
          font-size: 13px; font-weight: 700;
          cursor: pointer;
          transition: 0.2s;
          font-family: 'Cairo', sans-serif !important;
          white-space: nowrap;
        }
        .accept-all-btn:hover {
          background: #059669;
        }

        .premium-content-area { padding: 15px; }

        /* جدول حركات المعلمين بتنسيق شبيه بجدول الإكسل في صفحة الموظفين */
        .table-wrapper.transfers-table-wrapper {
          width: 100%;
          overflow-x: auto;
          background: var(--panel);
          border-radius: 6px;
          border: 1px solid var(--border);
          padding: 2px;
          box-sizing: border-box;
        }

        .excel-table.transfers-table {
          width: 100%;
          border-collapse: collapse;
          text-align: right;
          font-size: 13px;
          table-layout: auto;
          font-family: "Cairo", sans-serif;
        }

        .excel-table.transfers-table th {
          background: var(--panel-2);
          padding: 10px 12px;
          color: var(--accent);
          font-weight: 400; /* بدون بولد */
          border-bottom: 1px solid var(--border);
          white-space: nowrap;
        }
        
        .excel-table.transfers-table td {
          padding: 8px 12px;
          border-bottom: 1px solid var(--border);
          color: var(--text);
          white-space: nowrap;
          font-weight: 400; /* النصوص العادية بدون بولد */
        }

        /* تقليل المسافة الأفقية بين عمود الوظيفة والجنس لتوسعة الجدول */
        .excel-table.transfers-table td:nth-child(6),
        .excel-table.transfers-table th:nth-child(6),
        .excel-table.transfers-table td:nth-child(7),
        .excel-table.transfers-table th:nth-child(7) {
          padding-left: 6px;
          padding-right: 6px;
          text-align: center;
        }

        /* تقليل المسافة بين عمود الرقم واسم الموظف لتوسعة الجدول أكثر */
        .excel-table.transfers-table td:nth-child(2),
        .excel-table.transfers-table th:nth-child(2),
        .excel-table.transfers-table td:nth-child(3),
        .excel-table.transfers-table th:nth-child(3) {
          padding-left: 6px;
          padding-right: 6px;
        }

        .excel-table.transfers-table tbody tr:nth-child(even):not(.row-selected) {
          background: color-mix(in srgb, var(--accent) 5%, transparent);
        }

        .excel-table.transfers-table tbody tr:hover {
          background: color-mix(in srgb, var(--accent) 4%, transparent);
        }

        .excel-table.transfers-table tr.row-selected {
          background: color-mix(in srgb, #ef4444 6%, transparent);
        }

        .status-pill {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          padding: 3px 10px; /* حواف بسيطة حول النص فقط */
          border-radius: 999px; /* كبسولة حول النص */
          font-size: 12px;
          font-weight: 400;
          text-align: center;
          width: auto; /* الحجم يتبع طول النص فقط */
        }
        .status-pill.accepted { background: #10b98120; color: #10b981; border: 1px solid #10b98130; }
        .status-pill.rejected { background: #ef444420; color: #ef4444; border: 1px solid #ef444430; }

        .accept-row-btn {
          display: inline-flex;
          align-items: center;
          gap: 6px;
          background: #10b981;
          color: #fff;
          border: none;
          border-radius: 6px;
          padding: 6px 14px;
          font-size: 12px;
          font-family: Cairo;
          cursor: pointer;
          transition: background 0.2s;
          white-space: nowrap;
        }
        .accept-row-btn:hover {
          background: #059669;
        }

        /* توحيد مقاس زر القبول وشارة مقبول بالضبط */
        .accept-row-btn,
        .status-pill.accepted {
          height: 30px;
          min-width: 86px;
          padding: 0 14px;
          font-size: 12px;
          border-radius: 6px;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          gap: 6px;
          box-sizing: border-box;
        }

        /* التاريخ والوقت */
        .datetime-cell {
          text-align: center;
          white-space: nowrap;
        }
        .datetime-cell .dt-date {
          font-size: 13px;
        }
        .datetime-cell .dt-time {
          font-size: 12px;
          font-weight: 700;
          color: var(--accent);
          direction: ltr;
          margin-top: 2px;
        }

        .gender-text-m {
          color: #3b82f6;
          font-weight: 400;
        }
        .gender-text-f {
          color: #ec4899;
          font-weight: 400;
        }

        .status-text-only {
          font-size: 12px;
          font-weight: 400;
        }
        .status-text-only.accepted { color: #10b981; }
        .status-text-only.rejected { color: #ef4444; }

        .status-pill {
          width: fit-content;
          padding: 4px 12px;
          border-radius: 6px;
          font-size: 11px;
          font-weight: 400;
        }
        .status-pill.accepted { background: #10b98120; color: #10b981; border: 1px solid #10b98130; }
        .status-pill.rejected { background: #ef444420; color: #ef4444; border: 1px solid #ef444430; }

        .loader-overlay { padding: 40px; text-align: center; color: var(--muted); }
        .premium-loader { width: 30px; height: 30px; border: 2px solid var(--border); border-top-color: var(--accent); border-radius: 50%; animation: spin 1s infinite linear; margin: 0 auto 10px; }

        .empty-ui-state { text-align: center; padding: 60px; color: var(--muted); }
        .empty-ui-state .icon { font-size: 40px; opacity: 0.2; margin-bottom: 15px; }

        @media (max-width: 768px) {
          .premium-header-modern {
            position: relative !important;
            top: auto !important;
            z-index: 1 !important;
            padding: 12px;
          }
          .header-left {
            display: none !important;
          }
          .header-tools {
            width: 100%;
            align-items: stretch;
            flex-direction: column;
          }
          .global-search-container {
            width: 100%;
            max-width: 100%;
          }
          .premium-content-area {
            padding: 12px;
          }
          /* بطاقات الهاتف */
          .table-wrapper.transfers-table-wrapper {
            overflow: visible;
            border: none;
            background: transparent;
            padding: 0;
          }
          .excel-table.transfers-table thead {
            display: none;
          }
          .excel-table.transfers-table,
          .excel-table.transfers-table tbody {
            display: block;
            width: 100%;
          }
          .excel-table.transfers-table tbody {
            display: flex;
            flex-direction: column;
            gap: 10px;
          }
          .excel-table.transfers-table tr {
            display: flex;
            flex-wrap: wrap;
            align-items: center;
            background: var(--panel);
            border: 1px solid var(--border);
            border-radius: 6px;
            padding: 12px;
            box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
          }
          .excel-table.transfers-table td {
            display: block;
            border: none;
            padding: 3px 0;
            white-space: normal;
            word-break: break-word;
          }
          .excel-table.transfers-table td[data-label="#"] {
            display: none;
          }
          .excel-table.transfers-table td[data-label="select"] {
            flex-shrink: 0;
            margin-inline-end: 8px;
            align-self: center;
          }
          .excel-table.transfers-table td[data-label="name"] {
            flex: 1;
            min-width: 0;
            font-size: 15px;
            color: var(--text);
            line-height: 1.5;
            align-self: center;
          }
          .excel-table.transfers-table td[data-label="الحالة"] {
            flex-shrink: 0;
            margin-inline-start: auto;
            align-self: center;
          }
          .excel-table.transfers-table td[data-label]:not([data-label="#"]):not([data-label="select"]):not([data-label="name"]):not([data-label="الحالة"]) {
            flex-basis: 100%;
            width: 100%;
            font-size: 12px;
            color: var(--muted);
            display: flex;
            align-items: center;
            gap: 6px;
          }
          .excel-table.transfers-table td[data-label]:not([data-label="#"]):not([data-label="select"]):not([data-label="name"]):not([data-label="الحالة"])::before {
            content: attr(data-label) ":";
            color: var(--accent);
            font-size: 12px;
            flex-shrink: 0;
          }
        }
        
        @keyframes spin { to { transform: rotate(360deg); } }
      `}</style>
    </div>
  );
};

export default TransferredTeachers;
